module.exports = __webpack_public_path__ + "img/gift-box.dd34ab07.png";